export default {
  bind(el, bindings, vnode) {
    let menu = el.querySelector('.js-menu')
    let toggler = el.querySelector('.js-toggler')
   
    if (menu) {
      toggler.onclick = () => {
        menu.classList.toggle('is-active')
        toggler.classList.toggle('is-active')
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/js/directives/header/header.js